import React from "react";
import ajax from "./../../lib/ajax.js";
import ApplicantList from "./applicant-list.jsx";
import context from "./../../lib/context.js";
import { FormControl, ControlLabel, Button } from "react-bootstrap";
import { browserHistory } from "react-router";
import Navigation from "./../shared/navigation.jsx";

export default class ApplicantLogMain extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            applicantList: {
                applicants: [],
                total: 0,
                pageSize: 10,
                page: 0,
                positionTitle: ''
            },
            search: {
                startRowIndex: 0,
                maximumRows: 10,
                sortExpression: 'ApplicantID'
            },
            resources: {}
        }

        this.role = context.getRouteParam(this, "role");
        this.loadViewModel = this.loadViewModel.bind(this);
        this.loadResources = this.loadResources.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onSort = this.onSort.bind(this);
        this.onNewApplicantClick = this.onNewApplicantClick.bind(this);
        this.getLinks = this.getLinks.bind(this);
    }

    componentDidMount() {
        this.loadViewModel(this.state.search.startRowIndex, this.state.search.maximumRows, this.state.search.sortExpression);
        this.loadResources();
    }

    loadViewModel(startRowIndex, maximumRows, sortExpression) {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        const self = this;

        if (sortExpression == '')
            sortExpression = 'ApplicantID';

        ajax.vm()
            .get(`get-applicant-logs/${this.props.routeParams.requestId}/${startRowIndex}/${maximumRows}/${sortExpression}/${this.role}`)
            .then(function (res) {
                let data = res.data;
                let applicantList = self.state.applicantList;
                applicantList.applicants = data.applicants;
                applicantList.total = data.total;
                applicantList.positionTitle = data.positionTitle

                self.setState({
                    applicantList: applicantList
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    loadResources() {
        const self = this;

        ajax.vm()
            .get(`applicant-log-main-resources`)
            .then(function (res) {
                self.setState({ resources: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    onNavigate(page) {
        var search = this.state.search;
        search.startRowIndex = page * search.maximumRows;

        var applicantList = this.state.applicantList;
        applicantList.page = page;
        
        this.setState({
            search: search,
            applicantList: applicantList
        });

        this.loadViewModel(search.startRowIndex, search.maximumRows, search.sortExpression);
    }

    onSort(sortExpression) {
        var search = this.state.search;
        search.startRowIndex = 0;
        search.sortExpression = sortExpression;

        this.setState({
            search: search
        });

        this.loadViewModel(search.startRowIndex, search.maximumRows, search.sortExpression);
    }

    onStatusChange(event) {
        var search = this.state.search;
        search.status = event.target.value;
        search.startRowIndex = 0;

        var applicantList = this.state.applicantList;
        applicantList.page = 0;
        
        this.setState({
            search: search,
            applicantList: applicantList
        });

        this.loadViewModel(search.startRowIndex, search.maximumRows, search.sortExpression);
    }

    onNewApplicantClick(event) {
        browserHistory.push(context.routeUrl(`${this.role}/applicant-entry/${this.props.routeParams.requestId}/0`));
    }

    getLinks() {
        return [
            { name: this.state.resources.home, link: context.routeUrl('home'), active: true },
            { name: this.state.resources.positionRequisition, link: context.routeUrl(`${this.role}/prf-main`), active: true },
            { name: 'Req. ' + this.props.routeParams.requestId + ' (' + this.state.applicantList.positionTitle + ')', link: context.routeUrl(`${this.role}/request-entry/${this.props.routeParams.requestId}`), active: true },
            { name: this.state.resources.applicantLog, link: '#', active: false },
        ];
    }

    render() {
        return (
            <div className="container" style={{ "width": "100%", "paddingRight" : "20px", "paddingLeft" : "20px" }} >
                <div className="row hidden-sm hidden-xs">
                    <div className="col-md-12">
                        <h2 className="text-center ap-title">{this.state.resources.positionRequisitionApplicantLog}</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Navigation links={this.getLinks()} />
                    </div>
                    <div className="col-md-6">
                        <div className="pull-right">
                        <Button id="new-applicant" className="btn-info" onClick={this.onNewApplicantClick}>{this.state.resources.newApplicant}</Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ApplicantList vm={this.state.applicantList} role={this.role} onNavigate={this.onNavigate} onSort={this.onSort} search={this.state.search} />
                    </div>
                </div>
            </div>
        );
    }
}